import React from "react";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Text,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { useBusinessUnit } from "../../context/BusinessUnitContext";

const BusinessUnitSwitcher = ({ variant = "ghost", size = "sm" }) => {
  const {
    businessUnits,
    selectedBusinessUnit,
    selectedBusinessUnitId,
    setSelectedBusinessUnitId,
  } = useBusinessUnit();

  if (!businessUnits || businessUnits.length === 0) {
    return null; // company-wide access, nothing to switch
  }

  const handleSelect = (buId) => {
    if (buId !== selectedBusinessUnitId) {
      setSelectedBusinessUnitId(buId);
    }
  };

  return (
    <Menu>
      <MenuButton
        as={Button}
        variant={variant}
        size={size}
        rightIcon={<ChevronDownIcon />}
      >
        <Text isTruncated maxW="150px">
          {selectedBusinessUnit?.unit_name || selectedBusinessUnit?.unit_code || "Select BU"}
        </Text>
      </MenuButton>
      <MenuList>
        {businessUnits.map((bu) => (
          <MenuItem key={bu.id} onClick={() => handleSelect(bu.id)}>
            {bu.unit_name || bu.unit_code}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default BusinessUnitSwitcher;
